import React from 'react';
import { ButtonGroup, Button, Card, Spinner, Accordion } from 'ui';
import TextArea from 'components/shared/debouncedTextArea';
import ExampleRecording from 'components/editor/element/media_recording/ExampleRecording';
import ProviderIndependentExampleRecording from 'components/editor/element/media_recording/ProviderIndependentExampleRecording';
import { routes } from 'constants/config';
import Question from './Question';
import FeedbackContributorAutoComplete from './FeedbackContributorAutoComplete';

const ScenarioEditor = props => {
  const {
    scenarioId,
    features,
    scenario,
    loading,
    saved,
    updatePrompt,
    updateDescription,
    feedbackCriteria,
    updateTitle,
    updateFeedbackCriteria,
    identifier,
    potentialFeedbackContributors,
    filterSuggestions,
    onSuggestionSelected,
    onSuggestionRemoved,
    currentUserId,
    browserSupport,
    ziggeoApiKey,
  } = props;
  return (
    <div className="ScenarioEditor ff-ss p-24 maxw-layout">
      {loading && <Spinner />}
      {!loading && (
        <>
          <a
            href={routes.ON_DEMAND_PRACTICE.CREATOR.SHOW(scenarioId)}
            className="c-brand-blue td-u"
          >
            {t('practice.on_demand_practice.editor.scenario_overview')}
          </a>
          <div className="ScenarioEditor-header d-f jc-sb mb-16 mt-32">
            <h1 className="ff-ss fw-n">
              {t('practice.on_demand_practice.editor.scenario_builder')}
            </h1>
            <ButtonGroup>
              <div
                role="alert"
                aria-hidden={saved}
                className={`ScenarioEditor-saved ${
                  saved && 'ScenarioEditor-saved--shown'
                }`}
              >
                {t('common.saved')}
              </div>
              <Button
                url={routes.ON_DEMAND_PRACTICE.PREVIEW.SHOW(scenarioId)}
                target="_blank"
              >
                {t('common.preview')}
              </Button>
            </ButtonGroup>
          </div>
          <Card>
            <Card.Content padding="large">
              <label htmlFor="container-title" className="v-hide">
                {t('practice.on_demand_practice.editor.scenario_title')}
              </label>
              <TextArea
                id="container-title"
                value={scenario.title}
                className="ScenarioEditor-title fz-h1 Animated mb-8"
                onChange={updateTitle}
                placeholder={t(
                  'practice.on_demand_practice.editor.scenario_title',
                )}
                singleLine
              />
              <label htmlFor="container-description" className="v-hide">
                {t('practice.on_demand_practice.editor.scenario_description')}
              </label>
              <TextArea
                id="container-description"
                value={scenario.description}
                className="ScenarioEditor-description fz-24 Animated mb-16"
                onChange={updateDescription}
                placeholder={t(
                  'practice.on_demand_practice.editor.scenario_description',
                )}
                singleLine
              />
              <Question
                prompt={scenario.prompt}
                updatePrompt={updatePrompt}
                questionType={scenario.scenarioType}
                feedbackCriteria={feedbackCriteria}
                updateFeedbackCriteria={updateFeedbackCriteria}
                features={features}
              />
              <h3 className="ff-ss">
                {t(
                  'practice.on_demand_practice.editor.scenario_potential_feedback_contributors',
                )}
              </h3>
              <FeedbackContributorAutoComplete
                identifier={identifier}
                selectedSuggestions={potentialFeedbackContributors}
                scenarioId={scenarioId}
                filterSuggestions={filterSuggestions}
                onSuggestionSelected={onSuggestionSelected}
                onSuggestionRemoved={onSuggestionRemoved}
              />
              {scenario.isMediaType && (
                <Accordion
                  className="fw-w"
                  boldTitle
                  whiteBackground
                  fullWidth
                  contentClassName="p-16"
                  title={t('questions.question.media_recording.great_example')}
                >
                  {features.ziggeoForAllMedia &&
                  scenario.question.questionType !== 'audio_recording' ? (
                    <ProviderIndependentExampleRecording
                      browserSupport={browserSupport}
                      content={scenario.question}
                      currentUserId={currentUserId}
                      apiKey={ziggeoApiKey}
                      isOdp
                    />
                  ) : (
                    <ExampleRecording
                      browserSupport={browserSupport}
                      content={scenario.question}
                      currentUserId={currentUserId}
                    />
                  )}
                </Accordion>
              )}
            </Card.Content>
          </Card>
        </>
      )}
    </div>
  );
};

export default ScenarioEditor;
